import {FormGroup} from '@angular/forms';

export class FormsValidatorService {

  static removeValidator(objectForm: FormGroup, path: string) {
    objectForm.get(path).clearValidators();
    objectForm.get(path).updateValueAndValidity();
  }

}
